<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-8">
          <vx-card>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4 text-left">
                  <h3>{{ activeUserInfo.firstName }} {{activeUserInfo.lastName}}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-6">
                  <vs-input
                    v-validate="'required'"
                    :name="$t('firstname')"
                    v-model="user.firstName"
                    class="w-full mt-6"
                    :label-placeholder="$t('firstname')"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('firstname')) }}</span>
                </div>
                <div class="col-md-6 mt-6">
                  <vs-input
                    v-validate="'required'"
                    :name="$t('surname')"
                    :label-placeholder="$t('surname')"
                    v-model="user.lastName"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('surname')) }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-6">
                  <vs-input
                    v-validate="'required'"
                    :name="$t('email')"
                    :label-placeholder="$t('email')"
                    v-model="user.email"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('email')) }}</span>
                </div>
                <div class="col-md-6 mt-6">
                  <vs-button @click="updateUser" class="w-full mt-6">{{ $t('save') }}</vs-button>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.user.firstName != "" &&
        this.user.lastName != "" &&
        this.user.email != ""
      );
    },
  },
  data() {
    return {
      user: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
      },
      datas: "",
    };
  },
  computed: {
    activeUserInfo() {
      this.datas = localStorage.getItem("AppActiveUser");
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    getData() {
      this.user.id = this.activeUserInfo.id;
      this.user.firstName = this.activeUserInfo.firstName;
      this.user.lastName = this.activeUserInfo.lastName;
      this.user.email = this.activeUserInfo.email;
    },
    updateUser() {
      if (this.user.firstName == "") {
        return notify.warning(this.$t("fillName"));
      }
      if (this.user.lastName == "") {
        return notify.warning(this.$t("fillSurname"));
      }
      if (this.user.email == "") {
        return notify.warning(this.$t("fillEmail"));
      }
      let path = "/users/updateprofile";

      http.post(path, this.user).then((response) => {
        notify.success(this.$t("saved"), this.$t("updatedUser"));

        this.$store.state.AppActiveUser = this.user;
        localStorage.setItem("AppActiveUser", JSON.stringify(this.user));
        return this.$router.push("/home");
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>